import { TimerIcon } from 'components/icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Countdown.module.scss';

export type CountdownProps = {
  date: Date;
};

export default function Countdown({ date }: CountdownProps) {
  const { t } = useTranslation('countdown');
  const [timeLeft, setTimeLeft] = useState(
    date.getTime() - new Date().getTime(),
  );
  const countdownIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null,
  );
  const minutes = getFormattedTime(
    Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)).toString(),
  );
  const seconds = getFormattedTime(
    Math.floor((timeLeft % (1000 * 60)) / 1000).toString(),
  );
  const hours = getFormattedTime(
    Math.floor(
      (timeLeft - +minutes * 60 * 1000 - +seconds * 1000) / (1000 * 60 * 60),
    ).toString(),
  );

  useEffect(() => {
    countdownIntervalRef.current = setInterval(() => {
      setTimeLeft(date.getTime() - Date.now());
    }, 1000);

    return () => {
      if (countdownIntervalRef.current)
        clearInterval(countdownIntervalRef.current);
    };
  }, [date]);

  useEffect(() => {
    if (timeLeft <= 0 && countdownIntervalRef.current)
      clearInterval(countdownIntervalRef.current);
  }, [timeLeft]);

  function getFormattedTime(timeString: string) {
    if (+timeString <= 0) return '00';
    return ('0' + timeString).slice(-2);
  }

  return (
    <div className={styles.container} data-test="countdown">
      <div className={styles.icon}>
        <TimerIcon data-test="icon-timer" />
      </div>
      <div className={styles['timer-elements']}>
        <span data-test="countdown-hours">
          {hours}
          {t('hours')}:
        </span>
        <span data-test="countdown-minutes">
          {minutes}
          {t('minutes')}:
        </span>
        <span data-test="countdown-seconds">
          {seconds}
          {t('seconds')}
        </span>
      </div>
    </div>
  );
}
